import { globalCss } from '@stitches/react';

export const globalStyles = globalCss({
  '*, *::before, *::after': {
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
    lineHeight: '$3',
  },
  '*::placeholder': {
    fontStyle: 'italic',
    color: '$slate8',
  },
  'body': {
    background: '$slate2',
    overflow: 'hidden scroll',
    fontFamily: 'Roboto, $sans',
  },
  '.atom-container': { stroke: 'transparent' },
});
